import React from 'react';
import { Field, FormErrors, InjectedFormProps, reduxForm } from 'redux-form';

import { validatePassword } from 'mf-shared/utils/passwordValidator';

import ResetPasswordField from '../Fields/ResetPasswordField/ResetPasswordField';
import LoadingButton from '../LoadingButton';

import styles from './style.css';

const validate = (values: FormField) => {
  let errors: FormErrors<FormField> = {};
  errors = validatePassword(values.newPassword, values.confPassword);

  return {
    newPassword: errors.password,
    confPassword: errors.password_confirmation,
  };
};

const mapFormValidation = {
  form: 'ResetPasswordForm',
  touchOnBlur: false,
  touchOnChange: true,
  validate,
};

const formConnector = reduxForm<FormField, ResetPasswordFormProps>(
  mapFormValidation
);

interface FormField {
  newPassword: string;
  confPassword: string;
  password: string;
  password_confirmation: string;
}

interface ResetPasswordFormProps {
  readonly currentlySending?: boolean;
  readonly btnText: string;
}

interface ResetPasswordFormState {
  readonly showPassword: boolean;
}

type Props = ResetPasswordFormProps &
  InjectedFormProps<FormField, ResetPasswordFormProps>;

class ResetPasswordForm extends React.Component<Props, ResetPasswordFormState> {
  constructor(props: Props) {
    super(props);
    this.state = {
      showPassword: false,
    };
  }

  toggleEye = () => {
    this.setState({
      showPassword: !this.state.showPassword,
    });
  };

  render() {
    const { handleSubmit, valid, currentlySending, btnText } = this.props;
    const { showPassword } = this.state;

    return (
      <div className="col-md-12 no-padding">
        <form onSubmit={handleSubmit}>
          <p className={styles['description-reset-password']}>
            {
              'Password needs to include both lowercase and uppercase characters, at least one number, and must be 8 or more characters long.'
            }
          </p>
          <div className={`${styles['password-container']}`}>
            <Field
              component={ResetPasswordField}
              name="newPassword"
              type={showPassword ? 'text' : 'password'}
              placeholder={'New Password'}
              autoCorrect="off"
              maxLength={40}
              autoCapitalize="off"
              spellCheck="false"
            />
            <div className={`${styles.eyes}`} onClick={this.toggleEye}>
              {showPassword ? (
                <span className="glyphicon glyphicon-eye-open" />
              ) : (
                <span className="glyphicon glyphicon-eye-close" />
              )}
            </div>
          </div>

          <Field
            component={ResetPasswordField}
            name="confPassword"
            type="password"
            placeholder={'Retype new password'}
            autoCorrect="off"
            maxLength={40}
            autoCapitalize="off"
            spellCheck="false"
          />

          <div className={styles['submit-btn-container']}>
            {currentlySending ? (
              <LoadingButton />
            ) : (
              <button
                type="submit"
                className={`btn btn-primary center ${styles['submit-btn']}`}
                disabled={!valid}
              >
                {btnText}
              </button>
            )}
          </div>
        </form>
      </div>
    );
  }
}

export default formConnector(ResetPasswordForm);
